/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingBarService {
  private showStateSubject: BehaviorSubject<any> = new BehaviorSubject<boolean>(false);

  private hideTimeout: any;

  constructor() {}

  hide() {
    this.hideTimeout = setTimeout(() => {
      this.showStateSubject.next(false);
    }, 200);
  }

  show() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    this.showStateSubject.next(true);

    setTimeout(() => {
      this.showStateSubject.next(false);
    }, 5000);
  }

  getShowStateSubject(): Observable<boolean> {
    return this.showStateSubject;
  }
}
